import { useEffect, useState } from 'react';
import { logout } from '../api';

export default function LogoutPage() {
  const [loggingOut, setLoggingOut] = useState(true);

  useEffect(() => {
    logout().finally(() => setLoggingOut(false));
  }, []);

  if (loggingOut) {
    return <div>Logging out...</div>;
  }

  return <div>Logged out!</div>;
}
